<template>
    <form @submit.prevent="edit">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input
                            :model-value="customField?.name"
                            @update:model-value="customField.name = $event"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.type')">
                        <AppSelect
                            @update:model-value="type = $event"
                            :model-value="type.key"
                            :selected-value="type.value"
                            :options="customFieldsOptions"
                            option-key="key"
                            option-value="value"
                            disabled
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.show_in_order')">
                        <AppSwitch
                            :model-value="customField.show_in_order"
                            @update:model-value="customField.show_in_order = $event"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-12" v-if="type.key === CustomFieldTypes.SELECT">
                    <FormGroup :label="$t('labels.select_items')">
                        <Tags
                            :model-value="selectItems"
                            @update:model-value="selectItems = $event"
                            @keydown.enter.prevent
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="light" @click="remove" class="mr-2">
                <i class="icon-trash mr-2"></i>
                {{ $t('buttons.delete') }}
            </AppButton>
            <AppButton color="indigo" type="submit">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </form>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";
import Tags from "../../../../../components/new/form/Tags.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import AppSwitch from "../../../../../components/new/form/switch/AppSwitch.vue";

import { httpClient } from "../../../../../services/HttpClient";
import { CustomFieldTypes } from "../../../../enums/CustomFieldTypesEnum";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "MainInformationCard",
    components: {
        FormGroup, Input, AppSelect, Tags, AppButton, AppSwitch
    },
    emits: ['update:custom-field'],
    props: {
        customField: {
            type: [Object, null],
            default: null
        },
    },
    data() {
        return {
            CustomFieldTypes,
            type: {
                key: 'string',
                value: this.$t(`enum.custom_field.type.string`)
            },
            selectItems: '',
            customFieldsOptions: []
        }
    },
    methods: {
        edit() {
            let requestBody = {
                name: this.customField.name,
                show_in_order: this.customField.show_in_order
            }

            if (this.type.key === this.CustomFieldTypes.SELECT) {
                requestBody.select_items = this.selectItems.split(',').map(item => item.trim());
            }

            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/custom-fields/${this.$route.params.customFieldUuid}`, requestBody)
                .then((response) => {
                    new MessageNotificator().success(this.$t('alerts.success'));
                    this.$emit('update:custom-field', response.data.data);
                })
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.order_custom_field')
            }), () => {
            httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/custom-fields/${this.$route.params.customFieldUuid}`)
                .then(() => {
                    this.$router.push({ name: 'OrderCustomFieldsIndexPage' });
                })
            })
        }
    },
    mounted() {
        this.customFieldsOptions = Object.entries(this.CustomFieldTypes).map(([key, value]) => ({
            key: value,
            value: this.$t(`enum.custom_field.type.${value}`)
        }));

        this.type = this.customFieldsOptions.find(option => option.key === this.customField.type)
        this.selectItems = this.customField.select_items 
            ? this.customField.select_items.join(', ')
            : '';
    }
}
</script>